// src/pages/Gallery/AddGalleryPage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import "./AddGalleryPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function AddGalleryPage() {
  const navigate = useNavigate();

  // ===============================
  // Current User
  // ===============================
  const [currentUser, setCurrentUser] = useState({ name: "", email: "" });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setCurrentUser({
        name: user.name || user.fullname || "Admin",
        email: user.email,
      });
    }
  }, []);

  // ===============================
  // Form State
  // ===============================
  const [eventTitle, setEventTitle] = useState("");
  const [photos, setPhotos] = useState([]);
  const [createdBy, setCreatedBy] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (currentUser.name) {
      setCreatedBy(currentUser.name);
    }
  }, [currentUser]);

  // ===============================
  // Handlers
  // ===============================
  const handlePhotoChange = (e) => {
    setPhotos(e.target.files);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!eventTitle.trim()) {
      setError("Event title is required.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const formData = new FormData();
      formData.append("eventTitle", eventTitle);
      formData.append("createdBy", createdBy);

      // Append photos if selected
      if (photos.length > 0) {
        for (let i = 0; i < photos.length; i++) {
          formData.append("photos", photos[i]);
        }
      }

      await axios.post(`${API_BASE_URL}/gallery`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Gallery event created successfully!");
      navigate("/admin-panel/gallery-page");
    } catch (err) {
      console.error("Create Gallery Error:", err.response || err.message);
      setError(
        err.response?.data?.message ||
          "Failed to create gallery event. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-gallery-page">
      <motion.div
        className="add-gallery-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <button
          type="button"
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>

        <h2>Create Gallery Event</h2>

        <form onSubmit={handleSubmit}>
          {/* Event Title */}
          <div className="form-group">
            <label>Event Title</label>
            <input
              type="text"
              placeholder="Enter event title"
              value={eventTitle}
              onChange={(e) => setEventTitle(e.target.value)}
              required
            />
          </div>

          {/* Photos Upload */}
          <div className="form-group">
            <label>Upload Photos (Optional)</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handlePhotoChange}
            />
          </div>

          {/* Created By */}
          <div className="form-group">
            <label>Created By</label>
            <input type="text" value={createdBy} disabled />
          </div>

          {error && <div className="error-msg">{error}</div>}

          <motion.button
            type="submit"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            disabled={loading}
            className="submit-btn"
          >
            {loading ? "Creating..." : "Create Event"}
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
}